import { ChatkeeperIntegrationRequest } from "../IntegrationRequest/ChatkeeperIntegrationRequest";
import { ChatkeeperRequestTypeEnum } from "../types";

export class CompleteCaptchaRequest extends ChatkeeperIntegrationRequest {
  type: ChatkeeperRequestTypeEnum = ChatkeeperRequestTypeEnum.CompleteCaptcha;
}